import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type IconProps = Partial<SVGIconProps>;

const PaymentHistoryIcon: FC<IconProps> = (props) => (
  <SVGIcon viewBox="0 0 20 20" {...props}>
    <svg
      fill="none"
      height="20"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.083 9.417v-3.55c0-3.358-.783-4.2-3.933-4.2h-6.3c-3.15 0-3.933.842-3.933 4.2v9.383c0 2.217 1.217 2.742 2.692 1.158l.008-.008c.683-.725 1.725-.667 2.317.125l.842 1.125"
        strokeLinecap="round"
      />
      <path d="M15.167 17.833c1.473 0 2.667-1.194 2.667-2.667S16.639 12.5 15.167 12.5 12.5 13.694 12.5 15.167s1.194 2.667 2.667 2.667z" />
      <path
        d="M18.333 18.333L17.5 17.5M6.667 5.833h6.667M7.5 9.167h5"
        strokeLinecap="round"
      />
    </svg>
  </SVGIcon>
);

export default PaymentHistoryIcon;
